import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import './index.css'; // optional global styles
import { ThemeProvider } from '@mui/material/styles'  // Changed back to styles
import darkTheme from './theme' // or wherever your theme is exported
import { Box, CircularProgress, Fade } from '@mui/material';

// Componente de carga inicial
function LoadingScreen() {
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: '#121212',
        gap: 4,
        zIndex: 9999
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 4
        }}
      >
        <img
          src="/playmitos-full-logo.png"
          alt="PlayMitos Logo"
          style={{
            width: '200px',
            height: 'auto',
            animation: 'pulse 1s infinite'
          }}
        />
        <CircularProgress 
          size={40}
          sx={{
            color: '#1976d2'
          }}
        />
      </Box>
      <style>
        {`
          @keyframes pulse {
            0% {
              transform: scale(1);
              opacity: 1;
            }
            50% {
              transform: scale(1.05);
              opacity: 0.8;
            }
            100% {
              transform: scale(1);
              opacity: 1;
            }
          }
        `}
      </style>
    </Box>
  );
}

function AppWithLoading() {
  const [showApp, setShowApp] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowApp(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  if (!showApp) {
    return <LoadingScreen />;
  }

  return (
    <ThemeProvider theme={darkTheme}>
      <AuthProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <AppWithLoading />
  </React.StrictMode>
);